import { Injectable, ErrorHandler } from '@angular/core';
import { ToastService } from '../toast/toast.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private readonly toast: ToastService) {
    super();
  }

  public handleError(error: any) {
    if(error && typeof error === 'string') {
      this.toast.ShowError(error, false);
    }

    if (error && typeof error === "object") {
      // works with native Errors, custom errors, Axios errors, etc.
      if ("message" in error && typeof (error as any).message === "string") {
        this.toast.ShowError((error as any).message, false);
      }
    }
    super.handleError(error);
  }
}
